export const INITIALIZE_PAYMENT_SUCCESS = 'INITIALIZE_PAYMENT_SUCCESS'
export const INITIALIZE_PAYMENT_REQUEST = 'INITIALIZE_PAYMENT_REQUEST'
export const INITIALIZE_PAYMENT_FAILURE = 'INITIALIZE_PAYMENT_FAILURE'
export const INITIALIZE_PAYMENT_RESET = 'INITIALIZE_PAYMENT_RESET'
